import { getZrmListingInfo, getZrmRentalsLead, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import { type ClickstreamEventParams, SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_TYPE } from './globals';

const PERSONAL_INFO_WARNING_MODAL = 'personal_contact_details_warning_modal';
const EVENT_TEMPLATE_ID = '628';

// https://dataportal.zillowgroup.net/event-registry/8881
export const emitOpenPersonalInfoWarningModalEvent = ({
  user,
  listing,
  triggerLocation,
  lead,
}: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '8881',
      event_type_version_id: '4',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: PERSONAL_INFO_WARNING_MODAL,
      trigger_object_nm: 'reply_with_personal_info',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });

// https://dataportal.zillowgroup.net/event-registry/8882
export const emitSendAnywayInPersonalInfoWarningModalEvent = ({
  user,
  listing,
  triggerLocation,
  lead,
}: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: '8882',
      event_type_version_id: '3',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'send_anyway_button',
      trigger_object_nm: PERSONAL_INFO_WARNING_MODAL,
    },
    semantic: {
      semantic_event_nm: 'personal_info_warning',
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
